

import { Injectable, Inject } from '@angular/core';
import { Observable, of, combineLatest, onErrorResumeNext, Subject } from 'rxjs';
// tslint:disable-next-line: max-line-length
import { DwMdFormActionHandler, DwMdFormActionState, DwMdFormActionResult, DwFormAction, DwSecuritySSOService, DwSecurityRepositoryServiceToken, DwSecurityRepositoryService, DwSecurityUserService, DwMdFormContextInfo, DwOrmDataService, DwOrmDataServiceToken, DwMdFormInitActionHandler, DwMdFormInitActionState, DwAction, DwActionType, DwModalConfig, DwModalSize, DwDefaultFormPage, DwMenuActionType, DwModalButtonStandardConfigs, DwGridPreferences, DwUiConfigType, DwModalService } from '@devwareapps/devware-cap';
import { map, flatMap, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

import { MemoOfRecordEntity, CodeValueEntity, AppMetaDataService} from 'src/app/meta-data/app-meta-data.service';
import { ConfigService } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';
import { PositionHistoryGridComponent } from '../components/position-history-grid/position-history-grid.component';
import { filter } from 'mathjs';



@DwAction ({
  isGlobal: false,
  actionType: DwActionType.formAction,
  display: 'Employee History',
  keyName : 'employeeHistory',
  actionMessage: '',
  parentItemName : 'ems_UserExtended',
  defaultButtonConfig : {
    buttonText : 'Employee History',
    buttonTitle : 'Employee History',
    command : 'employeeHistory',
    iconClass : '',
    buttonClass : 'btn btn-success'
  }
})
@Injectable({
  providedIn: 'root'
})
export class EmployeeHistoryActionService implements DwMdFormActionHandler, DwMdFormInitActionHandler  {

   constructor(
     protected msalHandler: DwSecuritySSOService,
      protected securityService: DwSecurityUserService,
     @Inject(DwSecurityRepositoryServiceToken) protected securityRepository: DwSecurityRepositoryService,
     @Inject(DwOrmDataServiceToken) protected ormDataService: DwOrmDataService,
     private dwModalService: DwModalService,
     protected http: HttpClient) {
  }

  /**
   * Initialize the action to customize any config items
   * @param formInitActionState form state
   */
  initAction(formInitActionState: DwMdFormInitActionState) {
    return;
  }

  handleAction(formActionState: DwMdFormActionState): Observable<DwMdFormActionResult> {

    let modalConfig = new DwModalConfig();
    //this.ormDataService.getKeyValue()
    let filter = {
      UserId: formActionState.formApi.getFormData().EmployeeEthos_UserId
    }

    let gridPreferences = new DwGridPreferences();
    gridPreferences;
    const md = new AppMetaDataService();
    modalConfig.allowFullScreen = true;
    modalConfig.cloneData = false;
    modalConfig.modalSize = DwModalSize.extraLarge;
    modalConfig.data = {
        configKeyPart: 'PositionHistory',
        item: md.RoPositionHistory.ItemDetail.ItemName,
        preferences: gridPreferences,
        filter: filter,
    }

    modalConfig.component = PositionHistoryGridComponent;



    modalConfig.title = 'Employee History';
    modalConfig.buttons = [DwModalButtonStandardConfigs.instance.closeButton];

    const result: DwMdFormActionResult = {
      success : true,
      message : '',
      hideMessage: true,
    };

    this.dwModalService.showModal(modalConfig).pipe(flatMap(result =>{
      return of(result)
    }))

    return of(result);
  }


}
